<script setup>
</script>

<template>
  <div class="basis-full flex flex-col overflow-hidden single-main-tab-container">
    <div class="basis-full flex flex-col overflow-hidden single-main-tab-bg m-1 ml-0">
      <div class="basis-full flex flex-col p-1 overflow-y-auto">
        <div class="basis-full rounded-sm p-1 lx-content-container flex flex-col">

          <h1>EMPTY</h1>

        </div>
      </div>
    </div>
  </div>
</template>


<style scoped>

</style>
